import { createFileRoute } from "@tanstack/react-router";
import React, { Suspense, lazy } from "react";

// LL87 filing flow, Tracker-native (mirrors `portal/buildings_/.../ll97.tsx`).
// The trailing-underscore `buildings_` segment is the established repo
// escape-hatch: it keeps this route nested under `portal.tsx` (→ Tracker
// chrome: TrackerSidebar + gutter) but PREVENTS nesting under
// `routes/portal/buildings/$buildingId.tsx` (the BuildingDetail page,
// which renders WITHOUT an <Outlet/>). NO SiteHeader/backLink here —
// that is classic `/buildings` chrome; the flow renders its own
// "← Back to building" affordance (Flow/Page.tsx).
//
// Index route renders the LL87 FILING FLOW via the entry.tsx seam
// (redesign dispatcher today; flipping back to the legacy wizard is a
// one-line export change in pages/Filings/LL87Submission/entry.tsx).
// The read-only submission overview lives at `.../overview`.
const LL87FilingPage = lazy(() =>
  import("@/pages/Filings/LL87Submission/entry").then((m) => ({
    default: m.LL87SubmissionIndexPage,
  })),
);

/**
 * Flow-dispatcher search params (see Flow/dispatch.ts):
 *   - `screen`  — "extensions" (frame-13 chooser, workspace rail
 *     off-ramp) | "deferral_claim" (FR-P2-9 owner deferral CLAIM intake —
 *     a DISTINCT token from the base-state `deferral` record view) |
 *     "workspace" (frame-12 engage CTA).
 *   - `ext`     — "goodfaith" | "hardship" extension_pending framing.
 * Mirrors the /portal/chat lightweight validateSearch pattern. This is
 * one of the THREE normalization layers (this validator + the route
 * union + `readLl87FlowSearch`); a token added to only one is silently
 * stripped (FR-P2-9 edge case 3).
 */
export type Ll87SubmissionSearch = {
  screen?: "extensions" | "workspace" | "deferral_claim";
  ext?: "goodfaith" | "hardship";
};

const validateLl87SubmissionSearch = (
  search?: Record<string, unknown>,
): Ll87SubmissionSearch => {
  const screen = search?.screen;
  const ext = search?.ext;
  return {
    screen:
      screen === "extensions" ||
      screen === "workspace" ||
      screen === "deferral_claim"
        ? screen
        : undefined,
    ext: ext === "goodfaith" || ext === "hardship" ? ext : undefined,
  };
};

export const Route = createFileRoute(
  "/portal/buildings_/$buildingId/ll87_/$ll87SubmissionId/",
)({
  validateSearch: validateLl87SubmissionSearch,
  component: () => {
    const { buildingId, ll87SubmissionId } = Route.useParams();
    return (
      <Suspense fallback={null}>
        <LL87FilingPage
          buildingId={buildingId}
          submissionId={ll87SubmissionId}
        />
      </Suspense>
    );
  },
});
